module.exports = [
  'cdb_geocode_street_point',
  'cdb_isodistance',
  'cdb_isochrone',
  'OBS_GetDemographicSnapshot',
  'cdb_route_point_to_point',
  'cdb_route_with_waypoints'
];
